import { Pencil } from "@gravity-ui/icons";
import { Flex, Button, Icon } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import CreatableSelect from "react-select/creatable";
import { SELECT_STYLES } from "src/constants/selectStyle";
import {
  productSamplesModalAtom,
  productSelectionStore,
} from "src/store/atoms";

import { CustomOption } from "./components";
import { useProductSample } from "./hooks";
import { ProductSampleOption } from "./store/fetchers/getProductSamplesRequest";

export const ProductSamplesSelect = () => {
  const { value, options, onSelectChange } = useProductSample();
  const [selectedProductSample] = useAtom(
    productSelectionStore.currentSelectionAtom,
  );
  const openProductSamplesModal = useAction(productSamplesModalAtom);

  return (
    <Flex width={"100%"} gap={2} alignItems="flex-start">
      <div style={{ flex: 1 }}>
        <CreatableSelect<ProductSampleOption, false>
          isClearable
          isMulti={false}
          value={value}
          styles={SELECT_STYLES}
          onChange={onSelectChange}
          components={{ Option: CustomOption }}
          placeholder="Название выборки"
          options={options}
          formatCreateLabel={(inputValue) => `Создать "${inputValue}"`}
          noOptionsMessage={() => "Начните ввод для создания новой выборки"}
        />
      </div>
      <Button
        view="flat"
        disabled={!selectedProductSample}
        onClick={() => openProductSamplesModal(true)}
        title="Редактировать выборку"
      >
        <Icon data={Pencil} />
      </Button>
    </Flex>
  );
};
